import { Component, OnInit } from '@angular/core';
import { AuthenticationService, DataService, ToastrService } from '../../../_services';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import 'rxjs/Rx';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-password-change',
    templateUrl: './password-change.component.html',
    styleUrls: ['./password-change.component.css'],
    providers: [ToastrService]
})
export class PasswordChangeComponent implements OnInit {
    model: any = {};
    loading = false;
    userID: string;
    gID: string;
    private sub: any;
    usersForm: FormGroup;
    password: FormControl;
    cpassword: FormControl;
    _BTNcolor: string;
    redemptionParams: any;
    redemptionParamsStringified: string;


    constructor(private activatedRoute: ActivatedRoute,
        private router: Router,
        private _dataService: DataService,
        private authenticationService: AuthenticationService,
        private _route: ActivatedRoute,
        private _toastrService: ToastrService) {
        this.sub = this._route.params.subscribe(params => {
            this.userID = params['userID']; // (+) converts string 'id' to a number
            this.gID = params['gID'];
        });
        this.activatedRoute.queryParams.subscribe(p => {
            this.redemptionParamsStringified = (p['redemptionParams'] || '');
            // this.redemptionParamsStringified = decodeURIComponent(this.redemptionParamsStringified) || this.redemptionParamsStringified || '';
            this.redemptionParams = JSON.parse((p['redemptionParams'] || '{}'));
        });
    }

    ngOnInit() {
        this._BTNcolor = '#333';
        this.createFormControls();
        this.createForm();

        (<any>window).gtag('config', environment.gaId, { 'page_path': `/password-change` });
    }

    createFormControls() {
        this.password = new FormControl('', Validators.required);
        this.cpassword = new FormControl('', [Validators.compose(
            [Validators.required, this.validateAreEqual.bind(this, this.password)]
        )]);
    }

    private validateAreEqual(fieldControl: FormControl, fieldControl1: FormControl) {
        return fieldControl.value === fieldControl1.value ? null : {
            NotEqual: true
        };
    }

    private createForm() {
        this.usersForm = new FormGroup({
            userFormDetails: new FormGroup({
                password: this.password,
                cpassword: this.cpassword
            })
        });
    }

    onSubmit() {
        // console.log(this.usersForm);
        const formData = this.usersForm.controls.userFormDetails["controls"];
        formData['password'].markAsTouched(true);
        formData['cpassword'].markAsTouched(true);
    }

    changeColor(pass, cpass) {
        if (pass.length > 0) {
            if (pass === cpass) {
                this._BTNcolor = '#28a745';
            } else {
                this._BTNcolor = '#333';
            }
        }
    }

    passwordChange(form) {
        const formData = form.controls.userFormDetails.value;
        if (!this.usersForm.valid) {
            this.onSubmit();
            // console.log("Form is invalid!");
            return;
        }

        this.loading = true;
        const url = '/api/passwordChange';
        const body = {
            'password': formData.password,
            'cpassword': formData.cpassword,
            'userID': this.userID,
            'gID': this.gID
        };
        this._dataService.post(url, body)
            .subscribe(
                (data: { data: any, response: string, response_message: Array<any> }) => {
                    if (data.response === 'success') {
                        this._toastrService.typeCustomSuccess(data.response_message);
                        this.model = {};
                        this.router.navigate(['login'], { queryParams: { "redemptionParams": this.redemptionParamsStringified } });

                        (<any>window).gtag('event', 'Click', {
                            'event_category': 'Button Clicked',
                            'event_label': `Password Change Button by User ID ${this.userID}`
                        });
                    }
                },
                (error) => {
                    this._toastrService.typeCustomError(error.error.response_message || error.status_text);
                    this.loading = false;
                });
    }
}



// WEBPACK FOOTER //
// ./public/app/modules/login/password-change/password-change.component.ts